import { cn } from '@/utils/cn.ts';

interface ShortcutTooltipProps {
	label: string;
	shortcut: string;
	placement: 'left' | 'right';
}

export const ShortcutTooltip = ({
	label,
	shortcut,
	placement,
}: ShortcutTooltipProps) => {
	const position =
		placement === 'right'
			? 'left-full top-1/2 -translate-y-1/2 ml-2'
			: 'right-full top-1/2 -translate-y-1/2 mr-2';
	return (
		<span
			className={cn(
				`pointer-events-none absolute z-50 flex items-center gap-1.5 rounded-md
				bg-gray-800 px-2 py-1 text-xs whitespace-nowrap text-white opacity-0
				shadow-md transition-opacity group-hover:opacity-100
				group-focus-visible:opacity-100`,
				position,
			)}
		>
			{label}
			<kbd className="rounded bg-white/20 px-1 font-sans">{shortcut}</kbd>
		</span>
	);
};
